import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class ChecklistProgress implements IDataStorage {

    Index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  
    tableDefinition: InternalTable = new InternalTable('ChecklistProgress', 'Id', true, [
        this.Index
    ]);

    Id: number;
    Progress: string;

    static getTableDefinition(): InternalTable {
        return new ChecklistProgress().tableDefinition;
    }
}